<template>
  <c-dropdown
    :caret="false"
    placement="bottom-end"
    in-nav
    class="c-header-nav-item d-md-down-none mx-2"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <c-header-nav-link>
        <c-icon name="cil-list-rich" />
        <c-badge shape="pill" color="warning">{{ itemsCount }}</c-badge>
      </c-header-nav-link>
    </template>

    <notifications />

    <!--    <CDropdownHeader -->
    <!--      tag="div" -->
    <!--      class="text-center bg-light"-->
    <!--    >-->
    <!--      <strong>You have {{itemsCount}} pending tasks</strong>-->
    <!--    </CDropdownHeader>-->

    <!--    <CDropdownItem class="d-block">-->
    <!--      <div class="small mb-1">-->
    <!--        Upgrade NPM &amp; Bower <span class="float-right"><strong>0%</strong></span>-->
    <!--      </div>-->
    <!--      <CProgress class="progress-xs" color="info"/>-->
    <!--    </CDropdownItem>-->

    <!--    <CDropdownItem class="d-block">-->
    <!--      <div class="small mb-1">-->
    <!--        ReactJS Version <span class="float-right"><strong>25%</strong></span>-->
    <!--      </div>-->
    <!--      <CProgress class="progress-xs" color="danger" :value="25"/>-->
    <!--    </CDropdownItem>-->

    <!--    <CDropdownItem class="d-block">-->
    <!--      <div class="small mb-1">-->
    <!--        VueJS Version <span class="float-right"><strong>50%</strong></span>-->
    <!--      </div>-->
    <!--      <CProgress class="progress-xs" color="warning" :value="50"/>-->
    <!--    </CDropdownItem>-->

    <!--    <CDropdownItem class="d-block">-->
    <!--      <div class="small mb-1">-->
    <!--        Add new layouts <span class="float-right"><strong>75%</strong></span>-->
    <!--      </div>-->
    <!--      <CProgress class="progress-xs" color="info" :value="75"/>-->
    <!--    </CDropdownItem>-->

    <!--    <CDropdownItem class="d-block">-->
    <!--      <div class="small mb-1">-->
    <!--        Angular 2 Cli Version <span class="float-right"><strong>100%</strong></span>-->
    <!--      </div>-->
    <!--      <CProgress class="progress-xs" color="success" :value="100"/>-->
    <!--    </CDropdownItem>-->

    <!--    <CDropdownItem class="text-center border-top">-->
    <!--      <strong>View all tasks</strong>-->
    <!--    </CDropdownItem>-->
  </c-dropdown>
</template>
<script>
import Notifications from '@/views/components/Notifications';

export default {
  name: 'TheHeaderDropdownTasks',
  components: {
    Notifications,
  },
  data() {
    return { itemsCount: 15 };
  },
  computed: {
    // notifications () {
    //   return this.$store.state.messages.errors.reduce((toasters, toast) => {
    //     toasters[toast.position] = toasters[toast.position] || [];
    //     toasters[toast.position].push(toast);
    //     return toasters
    //   }, {})
    // },
  },
};
</script>
